import React, { useEffect, useState } from 'react';
import Button from 'src/components/button/Button';
import Toggle from 'src/components/checkbox/Toggle';
import useCookie from 'src/hooks/useCookie';
import { loadGoogleAnalytics, clearGoogleAnalyticsCookies } from 'src/util/analytics';
import './CookieConsentBanner.scss';

const CloseIcon = ({ onClick }) => (
  <svg onClick={onClick} className="close-button" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512">
    <path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z" />
  </svg>
);

export default function CookieConsentBanner() {
  const [showBanner, setShowBanner] = useState(false);
  const [showGranularControls, setShowGranularControls] = useState(false);
  const [analyticsEnabled, setAnalyticsEnabled] = useState(false);
  const { setCookie, getCookie } = useCookie('cookie-consent');

  useEffect(() => {
    const existing = getCookie();
    if (!existing) {
      setShowBanner(true);
    } else {
      setAnalyticsEnabled(existing.includes('analytics'));
    }
  }, []);

  const handleStrict = () => {
    setShowBanner(false);
    setAnalyticsEnabled(false);
    setCookie('none');
  };

  const handleAccept = () => {
    setShowBanner(false);
    setAnalyticsEnabled(true);
    setCookie('analytics');
    loadGoogleAnalytics();
  };

  const handleAnalyticsToggle = () => {
    const next = !analyticsEnabled;
    setAnalyticsEnabled(next);
    setCookie(next ? 'analytics' : 'none');
    if (next) {
      loadGoogleAnalytics();
    } else {
      clearGoogleAnalyticsCookies();
    }
  };

  if (!showBanner) {
    return (
      <div onClick={() => setShowBanner(true)} className="cookie-consent-button" title="Cookie settings">
        🍪
      </div>
    );
  }

  return (
    <div className="cookie-consent-banner">
      <CloseIcon onClick={() => setShowBanner(false)} />
      <h3>We use cookies</h3>
      <p>
        This website uses cookies to improve your experience.
      </p>
      {showGranularControls ? (
        <div className="granular-controls">
          <div className="cookie-option">
            <span>Necessary cookies</span>
            <Toggle value={true} disabled />
          </div>
          <div className="cookie-option">
            <span>Analytics</span>
            <Toggle value={analyticsEnabled} handleChange={handleAnalyticsToggle} />
          </div>
        </div>
      ) : (
        <Button onClick={() => setShowGranularControls(true)} className="white">Customise</Button>
      )}
      <Button onClick={handleStrict} className="white">Strictly necessary only</Button>
      {showGranularControls && (
        <Button onClick={() => setShowBanner(false)} className="white">Save</Button>
      )}
      <Button onClick={handleAccept} className="white">Accept all</Button>
    </div>
  );
}
